import { c as _c } from "react/compiler-runtime";
import { formatProductAttributes } from "@osmix/catalog-core/attributes";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { api, type CartItem } from "@/api";
import { Refresh20Icon, XIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { useFormatPrice } from "@/lib/use-format-price";
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetTitle } from "@/components/ui/sheet";
import { Skeleton } from "@osmix/ui/skeleton";

// «Детали заказа» — шторка слева 610 для товара «под заказ» (кадр 3919:17002,
// как «Все фильтры» каталога): шапка 20/23 w600 с крестиком, карточка товара
// #F8F8F8 r20, таблица характеристик #F8F8F8 r16 из реальных полей товара
// (categoryAttributes + цвет + срок изготовления), подпись и кнопки внизу.
// Строки без данных не рисуем — ничего не выдумываем. Данные товара тянем
// только пока шторка открыта (как в quick-view).
export function OrderDetailsModal(t0) {
  const $ = _c(27);
  const {
    item,
    open,
    onOpenChange
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("cart.orderDetails", {
      defaultValue: "\u0414\u0435\u0442\u0430\u043B\u0438 \u0437\u0430\u043A\u0430\u0437\u0430"
    });
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <SheetTitle className="text-[20px] leading-[23px] font-semibold tracking-[-0.31px] text-[#2E2E2E]">{t1}</SheetTitle>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("cart.orderDetails", {
      defaultValue: "\u0414\u0435\u0442\u0430\u043B\u0438 \u0437\u0430\u043A\u0430\u0437\u0430"
    });
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <SheetDescription className="sr-only">{t3}</SheetDescription>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("common.close");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <XIcon size={24} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <SheetClose aria-label={t5} className="grid size-6 shrink-0 place-items-center rounded-full text-[#1F1F1F] outline-none focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40">{t6}</SheetClose>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t7) {
    t8 = <div className="flex shrink-0 items-center justify-between gap-6 pt-[30px] pr-5 pb-2.5 pl-[30px]">{t2}{t4}{t7}</div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== item || $[18] !== onOpenChange) {
    t9 = item ? <OrderDetailsBody key={item.id} item={item} onDone={() => onOpenChange(false)} /> : null;
    $[17] = item;
    $[18] = onOpenChange;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <SheetContent side="left" showCloseButton={false} className="w-full gap-0 border-0 bg-white p-0 shadow-none sm:max-w-[610px]" data-testid="order-details">{t8}{t9}</SheetContent>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== onOpenChange || $[24] !== open || $[25] !== t10) {
    t11 = <Sheet open={open} onOpenChange={onOpenChange}>{t10}</Sheet>;
    $[23] = onOpenChange;
    $[24] = open;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}
function OrderDetailsBody(t0) {
  const $ = _c(91);
  const {
    item,
    onDone
  } = t0;
  const {
    t,
    i18n
  } = useTranslation();
  const fmt = useFormatPrice();
  const navigate = useNavigate();
  let t1;
  if ($[0] !== item.productId) {
    t1 = {
      queryKey: ["products", "get", item.productId],
      queryFn: () => api.products.get(item.productId)
    };
    $[0] = item.productId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const product = useQuery(t1);
  let t2;
  if ($[2] !== item.color || $[3] !== item.size || $[4] !== item.variantLabel) {
    t2 = item.variantLabel ?? [item.size, item.color].filter(Boolean).join(", ");
    $[2] = item.color;
    $[3] = item.size;
    $[4] = item.variantLabel;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const spec = t2;
  const t3 = product.data?.categoryAttributes;
  let t4;
  if ($[6] !== i18n.language || $[7] !== item.color || $[8] !== item.productionEstimate || $[9] !== product.data?.color || $[10] !== t || $[11] !== t3) {
    const attrRows = formatProductAttributes(t3, i18n.language);
    let t5;
    if ($[13] !== t) {
      t5 = t("cart.specColor", {
        defaultValue: "\u0426\u0432\u0435\u0442"
      });
      $[13] = t;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    const t6 = item.color || product.data?.color || "";
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
      t7 = [t5, t6];
      $[15] = t5;
      $[16] = t6;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    let t8;
    if ($[18] !== t) {
      t8 = t("cart.specProductionTime", {
        defaultValue: "\u0421\u0440\u043E\u043A \u0438\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u044F"
      });
      $[18] = t;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    const t9 = item.productionEstimate ?? "";
    let t10;
    if ($[20] !== t8 || $[21] !== t9) {
      t10 = [t8, t9];
      $[20] = t8;
      $[21] = t9;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    t4 = [...attrRows, t7, t10].filter(_temp);
    $[6] = i18n.language;
    $[7] = item.color;
    $[8] = item.productionEstimate;
    $[9] = product.data?.color;
    $[10] = t;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const rows = t4 as [string, string][];
  const hasOldPrice = item.oldUnitPrice != null && item.oldUnitPrice > item.unitPrice;
  let t5;
  if ($[23] !== item.name || $[24] !== item.photo) {
    t5 = item.photo && <img src={item.photo} alt={item.name} className="size-full object-cover" />;
    $[23] = item.name;
    $[24] = item.photo;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== t5) {
    t6 = <div className="h-[133px] w-[100px] shrink-0 overflow-hidden rounded-[16px] bg-white">{t5}</div>;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== fmt || $[29] !== item.unitPrice) {
    t7 = fmt(item.unitPrice);
    $[28] = fmt;
    $[29] = item.unitPrice;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== t7) {
    t8 = <span className="text-[20px] leading-[22px] font-bold tracking-[-0.4px] text-[#161616]">{t7}</span>;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] !== fmt || $[34] !== hasOldPrice || $[35] !== item.oldUnitPrice) {
    t9 = hasOldPrice && <span className="text-[14px] leading-[19px] font-bold tracking-[-0.28px] text-[#ABABAB] line-through">{fmt(item.oldUnitPrice as number)}</span>;
    $[33] = fmt;
    $[34] = hasOldPrice;
    $[35] = item.oldUnitPrice;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== t8 || $[38] !== t9) {
    t10 = <span className="inline-flex items-baseline gap-2">{t8}{t9}</span>;
    $[37] = t8;
    $[38] = t9;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  if ($[40] !== item.brand) {
    t11 = <span className="text-[14px] leading-[15px] font-semibold tracking-[-0.28px] text-[#161616]">{item.brand}</span>;
    $[40] = item.brand;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  let t12;
  if ($[42] !== item.name || $[43] !== spec) {
    t12 = [item.name, spec].filter(Boolean);
    $[42] = item.name;
    $[43] = spec;
    $[44] = t12;
  } else {
    t12 = $[44];
  }
  const t13 = t12.join(", ");
  let t14;
  if ($[45] !== t13) {
    t14 = <span className="text-[12px] leading-4 font-medium tracking-[-0.24px] text-[#797979]">{t13}</span>;
    $[45] = t13;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== t11 || $[48] !== t14) {
    t15 = <span className="flex flex-col gap-1">{t11}{t14}</span>;
    $[47] = t11;
    $[48] = t14;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  let t16;
  if ($[50] !== t10 || $[51] !== t15) {
    t16 = <div className="flex min-w-0 flex-1 flex-col justify-center gap-2">{t10}{t15}</div>;
    $[50] = t10;
    $[51] = t15;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  let t17;
  if ($[53] !== t16 || $[54] !== t6) {
    t17 = <div className="flex gap-3 rounded-[20px] bg-[#F8F8F8] p-2">{t6}{t16}</div>;
    $[53] = t16;
    $[54] = t6;
    $[55] = t17;
  } else {
    t17 = $[55];
  }
  let t18;
  if ($[56] !== product.isPending || $[57] !== rows) {
    t18 = product.isPending ? <div className="flex flex-col gap-2 rounded-[16px] bg-[#F8F8F8] p-2.5">{[0, 1, 2, 3].map(_temp2)}</div> : rows.length > 0 ? <dl className="flex flex-col rounded-[16px] bg-[#F8F8F8] px-2.5 py-2.5" data-testid="order-details-specs">{rows.map((t19, idx) => {
        const [key, value] = t19;
        return <div key={key} className={idx < rows.length - 1 ? "flex gap-0 border-b border-[#ECECEC] py-[11px]" : "flex gap-0 py-[11px]"}><dt className="w-[129px] shrink-0 text-[13px] leading-4 font-medium text-[#797979]">{key}</dt><dd className="min-w-0 text-[14px] leading-[17px] font-medium text-[#161616]">{value}</dd></div>;
      })}</dl> : null;
    $[56] = product.isPending;
    $[57] = rows;
    $[58] = t18;
  } else {
    t18 = $[58];
  }
  let t19;
  if ($[59] !== t) {
    t19 = t("cart.orderDetailsNote", {
      defaultValue: "\u041F\u043E\u0441\u043B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u0437\u0430\u043A\u0430\u0437 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0432 \xAB\u0417\u0430\u043A\u0430\u0437\u0430\u0445\xBB \u0432 \u043B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435."
    });
    $[59] = t;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] !== t19) {
    t20 = <p className="text-center text-[12px] leading-[17px] font-semibold text-[#ABABAB]">{t19}</p>;
    $[61] = t19;
    $[62] = t20;
  } else {
    t20 = $[62];
  }
  let t21;
  if ($[63] !== t17 || $[64] !== t18 || $[65] !== t20) {
    t21 = <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto pt-5 pr-5 pb-5 pl-[30px]">{t17}{t18}{t20}</div>;
    $[63] = t17;
    $[64] = t18;
    $[65] = t20;
    $[66] = t21;
  } else {
    t21 = $[66];
  }
  let t22;
  if ($[67] !== item.productId || $[68] !== navigate || $[69] !== onDone) {
    t22 = () => {
      onDone();
      navigate(`/product/${item.productId}`);
    };
    $[67] = item.productId;
    $[68] = navigate;
    $[69] = onDone;
    $[70] = t22;
  } else {
    t22 = $[70];
  }
  let t23;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Refresh20Icon size={20} />;
    $[71] = t23;
  } else {
    t23 = $[71];
  }
  let t24;
  if ($[72] !== t) {
    t24 = t("cart.repeatOrder", {
      defaultValue: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u0437\u0430\u043A\u0430\u0437"
    });
    $[72] = t;
    $[73] = t24;
  } else {
    t24 = $[73];
  }
  let t25;
  if ($[74] !== t22 || $[75] !== t24) {
    t25 = <Button variant="gray" className="text-ds-ink-2" onClick={t22}>{t23}{t24}</Button>;
    $[74] = t22;
    $[75] = t24;
    $[76] = t25;
  } else {
    t25 = $[76];
  }
  let t26;
  if ($[77] !== navigate || $[78] !== onDone) {
    t26 = () => {
      onDone();
      navigate("/chats");
    };
    $[77] = navigate;
    $[78] = onDone;
    $[79] = t26;
  } else {
    t26 = $[79];
  }
  let t27;
  if ($[80] !== t) {
    t27 = t("cart.chatWithSeller", {
      defaultValue: "\u0427\u0430\u0442 \u0441 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u043C"
    });
    $[80] = t;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  let t28;
  if ($[82] !== t26 || $[83] !== t27) {
    t28 = <Button onClick={t26}>{t27}</Button>;
    $[82] = t26;
    $[83] = t27;
    $[84] = t28;
  } else {
    t28 = $[84];
  }
  let t29;
  if ($[85] !== t25 || $[86] !== t28) {
    t29 = <div className="flex shrink-0 flex-wrap justify-end gap-4 pt-2.5 pr-5 pb-[30px] pl-[30px]">{t25}{t28}</div>;
    $[85] = t25;
    $[86] = t28;
    $[87] = t29;
  } else {
    t29 = $[87];
  }
  let t30;
  if ($[88] !== t21 || $[89] !== t29) {
    t30 = <>{t21}{t29}</>;
    $[88] = t21;
    $[89] = t29;
    $[90] = t30;
  } else {
    t30 = $[90];
  }
  return t30;
}
function _temp2(i) {
  return <Skeleton key={i} className="h-5 w-full" />;
}
function _temp(t0) {
  const [, v] = t0;
  return Boolean(v);
}
export default OrderDetailsModal;